'use client';

import { forwardRef } from 'react';

import {
  PasswordInput as MantinePasswordInput,
  type PasswordInputProps,
  type PasswordInputStylesNames,
} from '@mantine/core';

export interface IPasswordInput extends PasswordInputProps {
  error?: string | null;
  label?: string;
  id?: string;
  disabled?: boolean;
  classNames?: Partial<Record<PasswordInputStylesNames, string>>;
  dataTestId?: string;
  enablePasswordManagerAutofill?: boolean;
  placeholder?: string;
}

export const PasswordInput = forwardRef<HTMLInputElement, IPasswordInput>(
  (
    { label, id, error, disabled = false, classNames, dataTestId, enablePasswordManagerAutofill = false, ...rest },
    ref,
  ) => (
    <MantinePasswordInput
      styles={{
        error: { fontSize: '0.75rem' },
      }}
      label={label}
      error={error}
      disabled={disabled}
      data-testid={dataTestId}
      id={id}
      ref={ref}
      classNames={classNames}
      autoComplete={enablePasswordManagerAutofill ? 'one-time-code' : 'off'}
      data-lpignore={enablePasswordManagerAutofill ? undefined : 'true'} // lastpass
      data-1p-ignore={enablePasswordManagerAutofill ? undefined : 'true'} // 1Password
      {...rest}
    />
  ),
);
